import { OrderLine } from '@models/order';
import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

function useCalculatedRequest() {
    const request = useSelector((root: RootState) => root.order);

    const newOrderItems: OrderLine[] = request.orderLines.map((item) => {
        const {
            itemPrice, quantity, personalOptions, defaultOptions,
        } = item;
        const options = [...personalOptions, ...defaultOptions]
            .map((optionGroup) => optionGroup.options)
            .flat();

        const newOptions = options.map((option) => {
            const optionTotalAmount = option.optionPrice * option.quantity;
            return { ...option, totalAmount: optionTotalAmount };
        });
        const optionAmount = newOptions
            .map((option) => option.totalAmount)
            .reduce((acc, cur) => acc + cur, 0);
        const totalAmount = Math.max((itemPrice + optionAmount) * quantity, 0);
        return { ...item, totalAmount, options: newOptions };
    });

    const totalAmount = newOrderItems
        .filter(((item) => item.status === 'ON_SALE'))
        .map((item) => item.totalAmount)
        .reduce((acc, cur) => acc + cur, 0);

    // 포인트·선물 등 모든 할인 합산 (결제 금액 = totalAmount - totalDiscount)
    const totalDiscount = request.discounts?.map((d) => d.discountAmount)
        .reduce((acc, cur) => acc + cur, 0) || 0;

    // 쿠폰 할인만 분리 집계 (UI에서 쿠폰 절약 금액을 별도 표시할 때 사용)
    const totalCouponDiscount = request.discounts
        ?.filter((d) => !!d.couponId)
        .map((d) => d.discountAmount)
        .reduce((acc, cur) => acc + cur, 0) || 0;
    return {
        ...request,
        orderLines: newOrderItems,
        totalAmount,
        paymentAmount: totalAmount - totalDiscount,
        totalDiscount,
        totalCouponDiscount,
    };
}

export default useCalculatedRequest;
